// src/RouteChangeTracker.js
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { rotateCorrelationId } from "../utils/apiClient";

const RouteChangeTracker = () => {
	const location = useLocation();

	useEffect(() => {
		// #206: a fresh correlation id per page view, so a customer's whole journey through one
		// page groups under one id without merging into whatever they did on the last page.
		rotateCorrelationId();

		if (window.gtag) {
			window.gtag("config", "G-KPJW95BSEF", {
				page_path: location.pathname + location.search,
			});
		}
	}, [location]);

	return null;
};

export default RouteChangeTracker;
